/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useEffect } from 'react';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import { Breadcrumbs } from '../../../AbstractElements';
import { useStateContext } from '../../../contexts/ContextProvider';
import '../../../App.css'
import { Spinner } from '../../../AbstractElements';
import Grow from '@mui/material/Grow';
import { getUsers } from '../../../api/api';
import AddUsers from './AddUsers';
import UsersManagementTable from './UsersManagementTable';
import UsersSearchBar from './UsersSearchBar';

function containsError(item) {
  return Object.prototype.hasOwnProperty.call(item, 'Error');
}
function isObject(item) {
  return (typeof item === 'object' && !Array.isArray(item) && item !== null);
}

const UsersManagement = () => {
  const { basictoaster, loading, setLoading, users, setUsers } = useStateContext();

  useEffect(() => {
    // set ab to state and use this new ab in this code
    let newAbortController = new AbortController()
    setLoading(true);
    getUsers(newAbortController.signal).then((newsResp) => {
      if (!newAbortController.signal.aborted) {
        setUsers(newsResp);
        setLoading(false);
      }
    }).catch((err) => {basictoaster("error", "Errore utenti", err, () => {})});
    
    // Cleanup function to abort the request when the component unmounts
    return () => {
      newAbortController.abort();
    };
  }, [])

  // ALERT
  useEffect(() => {
    if (isObject(users) && containsError(users)) {
      basictoaster("error", "Errore utenti", users.Error, setUsers)
    }
  }, [users])

  return (
    <Fragment>
    <br />
      <Breadcrumbs phish mainTitle="Gestione utenti" parent="DomusVestra" title="Gestione utenti" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Grow in={true}><div>
            <Card>
              <CardBody>
                {/* <NewReq /><br /><br /> */}
                {loading ? (
                  <div className="loader-box">
                    <Spinner attrSpinner={{ className: 'loader-1' }} />
                  </div>
                ) : (
                  <>
                    <h2><b>Gestione utenti</b></h2><br />
                    <AddUsers /><br /><br />
                    <UsersSearchBar /><br />
                    <UsersManagementTable />
                  </>
                )}
              </CardBody>
            </Card>
            </div></Grow>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default UsersManagement;